import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IApiResponse } from '~global-interfaces/IApiResponse';
import { IPendingEvent, PendingEventCompletion } from '~global-interfaces/IHubAccount';

import { alsterAPI_URL } from '~api/api-urls';

/**
 * Talks HTTP only to the signed-in user's pending event (#686): the event they
 * picked while signing up from an event page, offered back after login. The
 * backend takes the address from the session, so nothing here sends one.
 */
@Injectable({ providedIn: 'root' })
export class PendingEventService {
  private readonly http = inject(HttpClient);
  private readonly url = alsterAPI_URL + 'hubuser/pending-event';

  getPendingEvent$(): Observable<IPendingEvent | null> {
    return this.http
      .get<IApiResponse<IPendingEvent | null>>(this.url)
      .pipe(map((response) => response?.data?.[0] ?? null));
  }

  completePendingEvent$(): Observable<PendingEventCompletion> {
    return this.http
      .post<IApiResponse<PendingEventCompletion>>(`${this.url}/complete`, {})
      .pipe(map((response) => response.data[0]));
  }

  dismissPendingEvent$(): Observable<void> {
    return this.http.post<IApiResponse<never>>(`${this.url}/dismiss`, {}).pipe(map(() => undefined));
  }
}
